import { FORM_MODES } from 'config/formModes';
import { CREATIVE_LIBRARY_ROUTE_PATH, ENTITY } from '../config';
import { generateFormPath } from '../utils/generateFormPath';

export const previewLibraryCreative = ({ data, context }) => {
    const { id: creativeId, accountName: accountId } = data;
    const { navigate } = context;
    const previewLibraryCreativePath = generateFormPath(CREATIVE_LIBRARY_ROUTE_PATH, {
        accountId,
        creativeId,
        entity: ENTITY.CREATIVE,
        mode: FORM_MODES.PREVIEW,
    });

    navigate(previewLibraryCreativePath);
};
